'use client'

import Footer3 from "@/components/theme/footers/Footer3";
import Header4 from "@/components/theme/headers/Header4";
import { CircularProgress, Stack } from "@mui/material";
import { AuthError } from "next-auth";
import { signIn, useSession } from "next-auth/react";
import { redirect, useSearchParams } from "next/navigation";
import { useState } from "react";

const ErrorMessage = ({ error, code }: { error?: string | null, code?: string | null }) => {
  if (!error) {
    return null
  }

  if (error === 'Configuration') {
    return (
      <div className="alert alert-danger" role="alert">
        Something went wrong on the server. Please contact admin.
      </div>
    )
  }

  if (error === 'AccessDenied') {
    return (
      <div className="alert alert-danger" role="alert">
        You are not allowed to log in. Please contact admin.
      </div>
    )
  }

  if (error === 'CredentialsSignin') {
    if (code === 'invalid_credentials') {
      return (
        <div className="alert alert-danger" role="alert">
          Username and/or password doesn&apos;t match. Please try again.
        </div>
      )
    }

    return (
      <div className="alert alert-danger" role="alert">
        An error occured, unable to log you in.
      </div>
    )
  }

  if (error === 'Verification') {

  }

  return (
    <div className="alert alert-danger" role="alert">
      An error occured, unable to log you in.
    </div>
  )
}

export default function Login() {
  const session = useSession()
  const searchParams = useSearchParams()
  console.log('sessionnnnnn', session)

  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)

  const error = searchParams.get('error')
  const code = searchParams.get('code')

  console.log({ error, code })

  if (session.status === 'authenticated') {
    return redirect(`/admin`)
  }

  return (
    <>
      <Header4 />

      <div>
        <div className="rainbow-gradient-circle" />
        <div className="rainbow-gradient-circle theme-pink" />
      </div>
      <div className="rainbow-blog-details-area">
        <div className="post-page-banner rainbow-section-gapTop">
          <div className="container">
            <div className="row">
              <div className="col-lg-8 offset-lg-2">
                <div className="content text-center">
                  <div className="page-title">
                    <h1 className="theme-gradient">Login</h1>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="blog-details-content pt--60 rainbow-section-gapBottom">
          <div className="container">
            <div className="row">
              <div className="col-lg-8 offset-lg-2">
                <div className="content">

                  <ErrorMessage error={error} code={code} />

                  {loading ? (
                    <CircularProgress />
                  ) : (
                    <Stack gap={2}>
                      <form onSubmit={async (e) => {
                        e.preventDefault();
                        setLoading(true)
                        console.log('callbackUrl', window.location.href)

                        try {
                          await signIn('credentials', {
                            email,
                            password,
                            callbackUrl: window.location.href, //'/admin',
                          })
                        } catch (error) {
                          if (error instanceof AuthError) {
                            return redirect(`/company/login?error=${error.type}`)
                          }
                          throw error
                        }
                      }}>
                        <div className="form-group">
                          <input
                            type="text"
                            name="email"
                            id="email"
                            placeholder="Email"
                            required
                            onChange={(e) => setEmail(e.target.value)}
                          />
                        </div>
                        <div className="form-group">
                          <input
                            type="password"
                            name="password"
                            id="password"
                            placeholder="Password"
                            required
                            onChange={(e) => setPassword(e.target.value)}
                          />
                        </div>
                        <div className="form-group">
                          <button
                            name="submit"
                            type="submit"
                            id="submit"
                            className="btn-default btn-large rainbow-btn"
                          >
                            <span>Login</span>
                          </button>
                        </div>
                      </form>
                    </Stack>
                  )
                  }

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


      <Footer3 />
    </>
  )
}